<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600");
@import url("https://fonts.googleapis.com/css?family=Fira+Sans:400,700&display=swap");
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
// Set your colors
$primary: #274f6e;
$primary-invert: findColorInvert($primary);
$primary-light: lighten($primary, 10%);
$primary-dark: darken($primary, 10%);
$light: #f0f9ff;
$light-invert: $primary;
$success: #298338;
$warning: #a56e1b;
$danger: #d14b54;
$info: #2962ff;
$input-placeholder-color: #737373; // to match b-select and more contrast
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$link: #3f6b8d;
$link-invert: findColorInvert($link);
$link-focus-border: $primary;
$link-hover: darken($link, 10%);
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "link": (
    $link,
    $link-invert,
    $link-light,
    $link-dark
  )
);
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

html,
body {
  @media screen and (min-width: 767px) {
    width: 100%;
    height: 100%;
  }
}
/* devsite css */
main.container {
  min-height: 70vh;
}
main.generic-container {
  min-height: 75vh;
}
html {
  scroll-behavior: smooth;
}
/* link css */
.widget-link {
  font-size: 1.25em;
  text-decoration: underline;
}
.disabled-link {
  font-size: 1.25em;
  text-decoration: none;
}
/* widget usage instructions css */
.widget-instructions {
  font-weight: $weight-semibold;
}
.comment-code {
  color: green;
  padding-left: 1.5rem;
}
.lorem-text {
  color: #4a5155;
  padding-left: 1.5rem;
}
.script-text {
  color: $primary-dark;
  padding-left: 1.5rem;
}
.lorem-code {
  color: #4a5155;
}
.sample-code {
  font-family: monospace;
  font-size: 15px;
  margin-bottom: 4px !important;
}
/* header, navbar and breadcrumb css */
.breadcrumb {
  margin-top: 12px;
}
.breadcrumb li:last-child > a {
  cursor: default;
  color: #6f6f6f;
}
.breadcrumb li:last-child > a:hover {
  color: #6f6f6f;
}
@media screen and (max-width: 1023px) {
  .breadcrumb {
    padding-left: 1em;
  }
}
.bp-header {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.navbar-item.has-dropdown:hover,
.navbar-item.has-dropdown.is-active,
.navbar-item.has-dropdown.is-active .navbar-link {
  background-color: transparent !important;
}
.navbar-dropdown {
  a.navbar-item {
    color: $primary !important;
  }
}
.navbar-dropdown {
  a.navbar-item:focus,
  a.navbar-item:focus-within,
  a.navbar-item:hover,
  a.navbar-item.is-active {
    color: $primary-dark !important;
  }
}
.navbar-menu.is-active {
  a.navbar-item {
    color: $primary !important;
  }
}
a.navbar-item {
  color: $light;
}
.navbar-item:hover {
  background-color: rgba(0, 0, 0, 0.3) !important;
}
a.navbar-item:focus,
a.navbar-item:focus-within,
a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-link:focus,
.navbar-link:focus-within,
.navbar-link:hover,
.navbar-link.is-active {
  background-color: transparent !important;
  color: $light !important;
}
.home-footer {
  align-items: center;
  text-align: center;
}
.partner-logos img {
  padding-bottom: 1rem;
  align-items: center;
  width: auto;
  height: auto;
  max-height: 60px;
}
img {
   display: inline-block !important; /* to avoid bbf.css overwritting img style */
}
.footer {
  margin-top: 1.5rem;
  background-color: #fafafa;
}
/* button css */
.button.is-primary:hover {
  background: #4b8bbb !important;
  text-decoration: none;
}
.button.is-primary.is-outlined:hover {
  background: #4b8bbb !important;
  border-color: #4b8bbb !important;
}
/* misc css */
.widget-subtitle {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.tile-header {
  margin-bottom: 1rem;
}
.title,
.subtitle {
  color: $primary;
}
.large-text {
  color: #4a4a4a;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.25;
}
.custom-section {
  padding: 24px;
}
.custom-tile {
  background: $light;
  display: flex;
  flex-direction: column;
}
.tile-footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
}
.list-bullet {
  margin: 20px 0px;
  list-style-type: disc;
  padding-left: calc(1.5em + 10px);
  li {
    margin-top: 10px;
  }
}

/* bizpal css */
em {
  color: inherit;
}

.bp-header .uk-navbar-nav > li > a,
.bp-header .uk-navbar-nav > li > span > a {
  font-size: 0.85em;
}
.uk-logo:hover,
.bp-header .uk-navbar-nav > li > a:hover,
.bp-header .uk-navbar-nav > li > span > a:hover {
  background: rgba(0, 0, 0, 0.3);
}
.bp-header .uk-navbar-nav > li > a:focus,
.bp-header .uk-navbar-nav > li > span > a:focus,
.uk-logo:focus {
  outline: 1px dotted rgba(255, 255, 255, 0.5);
  outline-offset: 4px;
  background: rgba(0, 0, 0, 0.3);
  @media screen and (min-width: 767px) {
  }
}
.bp-header .uk-subnav > * {
  padding-left: 5px;
  @media screen and (min-width: 767px) {
    padding-left: 20px;
  }
}
.bp-header .uk-subnav > * > a:focus {
  color: #eee;
}
.uk-navbar-nav > li > a:active,
.uk-navbar-nav > li > a:focus,
.uk-navbar-nav > li:hover > a,
.uk-navbar-nav > li > a.uk-open,
.bp-header .uk-navbar-nav > li > span > a:active,
.bp-header .uk-navbar-nav > li > span > a:focus,
.bp-header .uk-navbar-nav > li > span > a:hover {
  color: rgba(255, 255, 255, 1);
}
.uk-navbar-nav > li > span > a,
.uk-navbar-item,
.uk-navbar-toggle {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  padding: 0 15px;
  font-size: 0.875rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  text-decoration: none;
}
.bp-header {
  padding: 0 5px;
  @media screen and (min-width: 767px) {
    padding: 0 20px;
  }
}
.bp-header {
  background: #274f6e;
}
.box {
  box-shadow: none;
}
.card-header {
  box-shadow: none;
}
.term {
  margin-left: 40px;
  margin-top: 10px;
}
.term-item {
  margin-bottom: 10px;
}
.support-alignment {
  text-align: center !important;
}
</style>
